export default __webpack_public_path__ + "static/media/leagueHistory.99531f8e.svg";